import styled from 'styled-components';
import { utils } from '@makeship/core';
import { Caption } from '../../../Typography';

export const FaintCaption = styled(Caption)`
  color: ${({ theme }) => utils.hexToRGBA(theme.colors.neutral7, theme.alpha.dark)};
`;
